import { useState } from 'react';
import { InvoiceDeliveryMethodIntegerEnum } from 'src/shared/models/enums/invoiceDeliveryMethodInteger.enum';

// Central enum-like object for managing all modal keys across InvoiceMission
export const InvoiceMissionModalKeys = {
  CreateReminder: 'createReminder',
  DeliveryMethod: 'deliveryMethod',
  SendEmail: 'sendEmail',
  SendLetter: 'sendLetter',
  SendKivra: 'sendKivra',
} as const;

type InvoiceMissionModalKey = (typeof InvoiceMissionModalKeys)[keyof typeof InvoiceMissionModalKeys];
type ModalState = Record<InvoiceMissionModalKey, boolean>;

export const useInvoiceMissionModalState = () => {
  const [modals, setModals] = useState<ModalState>({
    createReminder: false,
    deliveryMethod: false,
    sendEmail: false,
    sendLetter: false,
    sendKivra: false,
  });
  const [deliveryMethod, setDeliveryMethod] = useState<InvoiceDeliveryMethodIntegerEnum | undefined>(undefined);

  const setModal = (key: keyof ModalState, value: boolean) => {
    setModals((prev) => ({ ...prev, [key]: value }));
  };

  const resetDeliveryState = () => {
    setModals((prev) => ({
      ...prev,
      deliveryMethod: false,
      sendEmail: false,
      sendLetter: false,
      sendKivra: false,
    }));
    setDeliveryMethod(undefined);
  };

  return {
    modals,
    setModal,
    deliveryMethod,
    setDeliveryMethod,
    resetDeliveryState,
  };
};
